import axios from 'axios';

let base = '/api';

export const getMenu = params => { return axios.get(`${base}/getMenu`); };
export const getListPage = params => { return axios.get(`${base}/`+params.actionurl, { params: params }); };
export const saveData = params => { return axios.get(`${base}/`+params.actionurl, { params: params });};
export const save = params => { return axios.get(`${base}/`+params.actionurl, { params: params });};
export const delData = params => { return axios.get(`${base}/`+params.actionurl, { params: params }); };
export const uptApi = params => { return axios.get(params.actionurl, { params: params }); };

export const uptOther = params => { return axios.get(params.actionurl, { params: params }); };


export const getUserList = params => { return axios.get(`${base}/user/getList`, { params: params }); };
export const getUserListPage = params => { return axios.get(`${base}/`+params.url, { params: params }); };

export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };

export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };

export function upFile(formData,id) {
	return axios.post(base+'/product/gktime/upFile?id='+id, formData, {
	  headers: {
		"Content-type": "multipart/form-data"
	  }
	}).then().catch();
}

export function postData(url,datas) {
	return axios.post(`${base}/`+url, datas);
}


// WEBPACK FOOTER //
// ./src/api/api.js